<template>
  <el-form ref="form" :rules="rules" :model="form" label-width="100px">
    <el-form-item label="機台編號" prop="AssetNo">
      <el-input v-model="form.AssetNo" />
    </el-form-item>

    <el-form-item label="機台型號">
      <el-select v-model="form.model.id" class="mr-3" placeholder="選擇機型" @change="onModelSelectChange">
        <el-option v-for="item in mvmModels" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
    </el-form-item>

    <el-form-item label="機台位置" prop="locate.name">
      <el-input v-model="form.locate.name">
        <el-button slot="append" type="success" @click="getGeoCode">定位</el-button>
      </el-input>
    </el-form-item>

    <el-form-item label="客戶名稱">
      <selectClient :client-id.sync="form.client.id" :company-id="companyId" @onSelect="onSelectClient" />
    </el-form-item>

    <el-form-item label="巡補員">
      <selectUser :user-id.sync="form.user.id" :company-id="companyId" @onSelect="onSelectUser" />
    </el-form-item>

    <el-form-item label="發票啟用時間">
      <el-date-picker disabledDate v-model="form.invoice_settings.EnableSince" type="date" placeholder="點擊修改啟用時間" :picker-options="pickerOptions" />
      <br />
      <el-switch v-model="form.invoice_settings.Invoice" active-color="#13ce66" active-text="啟用" inactive-color="#ff4949" inactive-text="不啟用" />
    </el-form-item>

    <el-form-item label="備註">
      <el-input v-model="form.description" type="textarea" />
    </el-form-item>

    <el-form-item>
      <el-button :loading="is_loading" type="primary" @click="onSubmit()">{{ id ? '更新機台' : '建立機台' }}</el-button>
      <el-button v-show="show_cancel" @click="onCancel">取消</el-button>
      <el-button v-show="!show_cancel" @click="onCancel">關閉</el-button>
    </el-form-item>

    <el-collapse v-if="id" v-model="collapse">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="text-danger">危險動作 <i class="header-icon el-icon-warning" /></div>
        </template>

        <el-select v-model="form.Status" class="mr-3" placeholder="機台狀態">
          <el-option v-for="item in Status" :key="item.Status" :label="item.name" :value="item.Status" />
        </el-select>
        <el-button type="primary" @click="onSubmit()">設定</el-button>
        <el-button :loading="is_loading" type="warning" @click="power('reboot')">機台重新開機</el-button>
        <el-button :loading="is_loading" type="danger" @click="power('poweroff')">機台關機</el-button>
      </el-collapse-item>
    </el-collapse>
  </el-form>
</template>
<script>
import { set_invoice_settings } from '@/api/ivm-mqtt';
import { updateMvm, getMvmModels, deleteMvm, getMvm } from '@/api/mvms';
import selectClient from '@/components/select/client.vue';
import companies from '@/components/select/companies.vue';
import selectUser from '@/components/select/user.vue';
import dayjs from 'dayjs';
import google from 'vue2-google-maps';
import mqtt from 'mqtt';

const methods = {
  async onSelectClient(id) {},
  async onSelectUser(id) {},
  onModelSelectChange(value) {
    this.form.model_id = value;
  },
  async onSubmit() {
    this.is_loading = true;
    this.wait_ack();
    this.form.invoice_settings.EnableSince = dayjs(this.form.invoice_settings.EnableSince, 'YYYY/MM/DD HH:mm:ss').format('YYYY/MM/DD HH:mm:ss');
    try {
      const valid = await this.$refs['form'].validate().catch((err) => {
        return err;
      });
      if (valid) {
        const data = await updateMvm(this.form);
        const res = await set_invoice_settings(
          {
            wholesaler: this.form.wholesaler,
            asset_no: this.form.AssetNo,
            customer_code: this.form.client.customer_code,
            op_locate_id: this.form.op_locate.id,
          },
          '2',
          this.form.invoice_settings,
        );
        // console.log('onSubmit', data);
        // console.log('onSubmit', res);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async deleteItem() {
    try {
      const data = await deleteMvm({ uid: this.form.uid });
      this.$message({
        message: '成功',
        type: 'success',
      });
      this.$emit('onSubmit');
    } catch (error) {}
  },
  async getGeoCode() {
    const googleMap = await this.$gmapApiPromiseLazy();
    const geocoder = new google.maps.Geocoder();

    try {
      const { results } = await geocoder.geocode({
        address: this.form.locate.name,
      });
      this.$message({
        message: '定位成功',
        type: 'success',
      });
      this.form.locate.lat = results[0].geometry.location.lat();
      this.form.locate.lng = results[0].geometry.location.lng();
    } catch (error) {
      this.$message({
        message: '定位失敗',
        type: 'error',
      });
    }
  },
  onCancel() {
    this.$emit('onCancel');
  },
  async end_mqtt() {
    try {
      await this.mqtt_client.unsubscribe(this.topic);
      await this.mqtt_client.end();
    } catch (error) {
      console.error(error);
    }
  },
  async init_mqtt(url, options) {
    try {
      this.mqtt_client = mqtt.connect(url, options);
      this.topic = `${this.form.wholesaler}/${this.form.AssetNo}/settings/invoice_settings/ack`;
      this.mqtt_client.on('connect', () => {
        this.mqtt_client.subscribe(this.topic, { qos: 2 }, (err, granted) => {
          if (err) {
            console.error('subscribe', err);
          }
          // console.log(granted);
        });
      });

      this.mqtt_client.on('message', async (topic, payload) => {
        if (topic !== this.topic) return;
        let { message_type, received_data } = JSON.parse(payload.toString());
        this.$message({
          message: '操作成功',
          type: 'success',
        });
        clearTimeout(this.wait_timer);
        this.$emit('onSubmit');
      });
    } catch (error) {
      console.error('created', 'ivm mqtt error');
      console.error('created', error);
    }
  },
  wait_ack() {
    clearTimeout(this.wait_timer);
    this.$message({
      message: '請稍候，等待機台回應',
    });
    this.wait_timer = setTimeout(() => {
      this.show_cancel = false;
      this.$message({
        message: '機台無回應，請稍後再重試，按下「更新機台」按鈕後，務必看到網頁顯示「操作成功」的訊息，方能確保完成設定，請點擊「關閉」以關閉',
        type: 'warning',
      });
      clearTimeout(this.wait_timer);
    }, 5000);
  },
  async power(action) {
    this.is_loading = true;
    const topic = `${this.form.wholesaler}/${this.form.AssetNo}/utilities/power`;
    // console.log(topic);
    try {
      const data = { action, customer_code: this.form.client.customer_code, op_locate_id: this.form.op_locate_id };
      this.mqtt_client.publish(topic, JSON.stringify(data), { qos: 2 }, (err, packet) => {
        if (err) {
          const err_msg = `發生錯誤: ${err}`;
          this.$message({
            message: err_msg,
            type: 'error',
            duration: 60000,
          });
        } else {
          const power_action = action === 'poweroff' ? '關機' : '重新開機';
          const msg = `已對${this.form.wholesaler}的${this.form.AssetNo}機台發送${power_action}的請求`;
          this.$message({
            message: msg,
            type: 'success',
            duration: 60000,
          });
          this.onCancel();
        }
      });
      // console.log('power action:', action);
    } catch (e) {
      console.error(e);
    }
  },
};
export default {
  components: {
    selectClient,
    companies,
    selectUser,
  },
  props: ['mvm', 'companyId', 'clientId', 'id', 'userId'],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          // time 是一個時間對象
          return time.getTime() < Date.now(); // 不能選擇當日之前的日期
        },
      },
      mvmModels: [],
      collapse: 1,
      Status: [
        { name: '已註冊', Status: 1 },
        { name: '未註冊', Status: 4 },
      ],
      form: {
        AssetNo: '',
        description: '',
        Status: 1,
        client_id: null,
        user_id: null,
        client: { id: null },
        user: { id: null },
        model: { id: null },
        locate: {
          name: '',
          description: '',
          lat: null,
          lng: null,
        },
        invoice_settings: {
          Invoice: false,
          EnableSince: '2022/02/01 00:00:00',
        },
      },
      rules: {
        AssetNo: [{ required: true, message: '必填', trigger: 'blur' }],
        name: [{ required: true, message: '必填', trigger: 'blur' }],
        select: [{ required: true, message: '必填', trigger: 'blur' }],
        locate: {
          name: [{ required: true, message: '必填', trigger: 'blur' }],
        },
      },
      mqtt_client: null,
      topic: '',
      is_loading: false,
      wait_timer: null,
      show_cancel: true,
    };
  },
  async created() {
    this.mvmModels = await getMvmModels();
    if (this.id) {
      this.form = await getMvm(this.id);
      // console.log('form', this.form);
      this.form.user = this.form.user ? this.form.user : { id: null };
    } else {
      this.form.client.id = this.clientId;
      this.form.user.id = this.userId;
      this.form.model.id = 1;
    }

    this.form.locate = this.form.locate
      ? this.form.locate
      : {
          name: '',
          description: '',
          lat: null,
          lng: null,
        };
    let url = process.env.VUE_APP_MQTT_URL;
    let options = {
      clean: false, // 收到離線時的 QoS 1,2 訊息
      connectTimeout: 30 * 1000, // ms
      reconnectPeriod: 4000, // ms
      clientId: process.env.VUE_APP_MQTT_CLIENT_ID,
      username: process.env.VUE_APP_MQTT_USERNAME,
      password: process.env.VUE_APP_MQTT_PASSWORD,
    };
    this.init_mqtt(url, options);
  },
  beforeDestroy() {
    try {
      this.end_mqtt();
      clearTimeout(this.wait_timer);
    } catch (error) {
      console.error(error);
    }
  },
  methods,
};
</script>
